import {
  dispatchLoadingMessage,
  JS_DOWNLOADING_LOADER_ID,
} from '@axa-asia/emma-loading-widget';

export const loadWithSpinner = async (loaderCb, getComponentCb) => {
  // Show loading widget for lazy-load component
  dispatchLoadingMessage({
    loaderId: JS_DOWNLOADING_LOADER_ID,
    target: 'overlay',
    isLoading: true,
    content: 'spinner',
  });

  const m = await loaderCb();
  const loadedComponent = m.default || m;

  // Hide loading widget for lazy-load component
  dispatchLoadingMessage({
    loaderId: JS_DOWNLOADING_LOADER_ID,
    target: 'overlay',
    isLoading: false,
    content: 'spinner',
  });

  if (typeof getComponentCb === 'function') return getComponentCb(null, loadedComponent);
  return loadedComponent;
};
